// Version : 0.0.1
// Author : SATHISH
// LastEdit : SATHISH
// MODFIED DATE:11-10-2025
//Last ADD :CODE REVIEW CHANGES AND ADD VERSION

import groupReportTypes from './group.report.types';

/** ***************** FETCH ALL GROUP REPORT DETAILS START *********************** */
export const fetchAllGroupReportStart = (addData: any) => ({
	type: groupReportTypes.GET_GROUP_REPORT_START,
	payload: addData,
});

export const fetchAllGroupReportSuccess = (successData: any) => ({
	type: groupReportTypes.GET_GROUP_REPORT_SUCCESS,
	payload: successData,
});

export const fetchAllGroupReportFailure = (failureData: any) => ({
	type: groupReportTypes.GET_GROUP_REPORT_FAILURE,
	payload: failureData,
});

export const fetchAllGroupReportResponseReset = () => ({
	type: groupReportTypes.GET_GROUP_REPORT_RESPONSE_RESET_START,
});

export const fetchAllGroupReportResponseResetChanged = () => ({
	type: groupReportTypes.GET_GROUP_REPORT_RESPONSE_RESET_CHANGED,
});

/** *****************  FETCH ALL GROUP REPORT DETAILS END *********************** */
